import { Skeleton } from '@/components/ui/skeleton';

const ROWS = ['w-2/5', 'w-3/5', 'w-1/3', 'w-2/4', 'w-3/5', 'w-1/4', 'w-2/5', 'w-1/2'];

/**
 * The Suspense fallback for a module chunk. It has the shape of a real page —
 * header, toolbar, rows — so the panel never flashes empty while the chunk
 * downloads and the layout does not shift once it lands.
 */
export function ContentSkeleton() {
  return (
    <div className="flex min-h-0 flex-1 flex-col" role="status" aria-label="Cargando la vista">
      <div className="flex shrink-0 items-end justify-between gap-4 border-b border-border px-6 py-4">
        <div className="space-y-2">
          <Skeleton className="h-7 w-44" />
          <Skeleton className="h-3.5 w-64" />
        </div>
        <Skeleton className="h-9 w-32" />
      </div>

      <div className="flex shrink-0 items-center gap-2 px-6 py-3">
        <Skeleton className="h-8 w-72" />
        <Skeleton className="h-8 w-28" />
        <Skeleton className="h-8 w-28" />
      </div>

      <div className="min-h-0 flex-1 space-y-px px-6">
        {ROWS.map((width, index) => (
          <div key={`${width}-${index}`} className="flex h-[52px] items-center gap-3">
            <Skeleton className="size-7 shrink-0 rounded-full" />
            <Skeleton className={`h-3.5 ${width}`} />
          </div>
        ))}
      </div>
    </div>
  );
}
